import { useMutation } from '@tanstack/react-query';

import { handleError, handleSuccess } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../../logic';
import { ApiErrorResponse } from '../../../../types';
import { postResetBrokerTwoFactor } from '../../requests/postResetBrokerTwoFactor';

export const useResetBrokerTwoFactor = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (userId: string) =>
      postResetBrokerTwoFactor(constructPost, userId),
    onSuccess: () => handleSuccess('2FA reset.'),
    onError: (error: ApiErrorResponse) =>
      handleError(
        getApiErrorMessage(
          error,
          'Failed to reset broker two factor authentication.',
        ),
      ),
  });
  return { resetBrokerTwoFactor: mutateAsync, ...rest };
};
